export default{
    zqdetail:{
        titleState:{
            title1:'Payment Term Settlement',
            title2:'Settlement Details'
        },
        msgState:{
            msg1:'Automatically reconciled after timeout',
            msg2:'Within',
            msg3:'natural days after reconciliation',
            msg4:'Due in',
            msg5:'days',
            msg6:'Overdue by',
            msg7:'days',
        },
        btnState:{
            btn1:'Confirm Reconciliation',
            btn2:'Dispute Reconciliation',
            btn3:'Pay Now',
            btn4:'Approve Invoice',
            btn5:'Reject Invoice',
            btn6:'Modify Invoice',
            btn7:'Request Invoice',
            btn8:'View Details',
            btn9:'No Invoice Needed',
            btn10:'Invoice Required',
        },
        jsdxx:{
            psInfo1:'Settlement Information',
            psInfo2:'Settlement No.:',
            psInfo3:'Merchant Name:',
            psInfo4:'Reconciliation Date:',
            psInfo5:'Reconciliation Period:',
            psInfo6:'Final Payment Date:',
            psInfo7:'Settlement Amount:',
            psInfo8:'Orders Count:',
            psInfo9:'Total Order Amount:',
            psInfo10:'Refund Orders:',
            psInfo11:'Total Refund Amount:',
            psInfo12:'Settlement Total:',
            psInfo13:'Settlement Log',
        },
        fapiaoxx:{
            fkInfo1:'Invoice Information',
            fkInfo2:'Invoiceable Amount:',
            fkInfo3:'Invoice Type:',
            fkInfo4:'Invoice Title:',
            fkInfo5:'Unified Social Credit Code:',
            fkInfo6:'Registered Address:',
            fkInfo7:'Registered Phone:',
            fkInfo8:'Bank Name:',
            fkInfo9:'Bank Account:',
        },
        kpxx:{
            qxInfo1:'Invoice Status:',
            qxInfo2:'Download E-Invoice',
            qxInfo3:'Carrier:',
            qxInfo4:'Invoice Remarks:',
            qxInfo5:'Tracking Number:',
            qxInfo6:'Copy Number',
            qxInfo7:'Track Progress',
            qxInfo8:'No invoice request submitted',
            qxInfo9:'Invoice Details',
        },
        table:{
            setp1:'Order Number',
            setp2:'Order Date',
            setp3:'Order Amount',
            setp4:'Refund Amount',
            setp5:'Payable Amount',
            setp6:'Store Name',
            setp7:'Action',
        },
        dialogState:{
            dil1:'Order Tracking',
            dil2:'Carrier:',
            dil3:'Tracking Number:',
            dil4:'Confirm',
            dil5:'Settlement Log',
            dil6:'Operation Time:',
            dil7:'Operator:',
        },
        confirmState:{
            confirm1:'Notification',
            confirm2:'Confirm',
            confirm3:'Cancel',
            confirm4:'Cancelled',
            confirm5:'Require invoice from merchant?',
            confirm6:'Confirm reconciliation discrepancy? Click to contact platform support',
            confirm7:'Enter invoice rejection reason',
            confirm8:'Input invoice rejection reason',
            confirm9:'E-Invoice',
            confirm10:'Download successful',
            confirm11:'Copied successfully',
        }
    }
}